<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div style="padding-top: 5%">
    <h3 style="font-weight: bold; color: #4a4949; font-size: 32px">
      <button @click="voltar()" class="btn btn-primary" style="font-size: 18px; font-weight: bold; padding: 5px 18px 5px 18px; margin-right: 5px">
        Voltar
      </button>
      LOTE {{ lote.lote_numero + " - " + lote.lote_titulo }}
    </h3>
    <br />
    <div class="row">
      <section class="col-lg-8">
        <section class="content">
          <!-- CARD CARROSSEL GALERIA IMAGENS FOTOS -->
          <div class="card card-solid" v-if="fotos && fotos.length">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-sm-12" style="background-color: white">
                  <div class="col-12" style="max-height: 350px; min-width: 300px; text-align: center">
                    <img
                      :src="getImageThumb(foto_selecionada)"
                      class="product-image"
                      style="cursor: pointer; object-fit: scale-down; max-width: 550px; max-height: 390px; padding: 10px 10px 10px 10px"
                      data-toggle="modal"
                      data-target="#image-modal"
                    />
                  </div>

                  <!-- TAGS DE STATUS QUANDO JÁ TEM A TAG DESOCUPADO-->
                  <div style="position: absolute; float: right; top: 0px; right: 5px" v-if="lote.lote_situacao == 'desocupado'">
                    <span
                      class="right badge badge-success"
                      style="margin-right: 3px; text-transform: uppercase; font-size: 18px; background-color: red !important"
                      v-if="lote.lote_status == 'retirado'"
                    >
                      Lote retirado
                    </span>

                    <span
                      class="right badge badge-success"
                      style="margin-right: 3px; text-transform: uppercase; font-size: 18px"
                      v-if="lote.lote_status == 'vendido'"
                    >
                      Lote vendido
                    </span>

                    <span
                      class="right badge badge-success"
                      style="margin-right: 3px; text-transform: uppercase; font-size: 18px; background-color: #301904 !important"
                      v-if="lote.lote_status == 'sem_licitante'"
                    >
                      Lote sem licitante
                    </span>

                    <span class="right badge badge-success" style="background-color: #301904 !important; text-transform: uppercase; font-size: 18px">
                      Desocupado
                    </span>
                  </div>

                  <!-- TAGS SEM  STATUS DESOCUPADO-->
                  <div style="position: absolute; float: right; top: 0px; right: 5px" v-else>
                    <span class="right badge badge-success" style="text-transform: uppercase; font-size: 18px" v-if="lote.lote_status == 'vendido'">
                      Lote vendido
                    </span>

                    <span
                      class="right badge badge-success"
                      style="text-transform: uppercase; font-size: 18px; background-color: #301904 !important"
                      v-if="lote.lote_status == 'sem_licitante'"
                    >
                      Lote sem licitante
                    </span>

                    <span
                      class="right badge badge-success"
                      style="text-transform: uppercase; font-size: 18px; background-color: red !important"
                      v-if="lote.lote_status == 'retirado'"
                    >
                      Lote retirado
                    </span>
                  </div>

                  <!-- TAGS LANCE -->
                  <div v-if="!pracas_fechadas">
                    <div
                      style="position: absolute; float: left; bottom: 60px; left: 0px"
                      v-if="lote.lote_lance > 0 && leilao.leilao_1_modalidade != 'venda'"
                    >
                      <span class="left badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                        Maior lance: R$ {{ toCurrency(lote.lote_lance) }}
                      </span>
                      <div v-if="lote.user">
                        <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                          {{ getApelidoFormatado(lote.user.apelido) }}
                        </span>
                      </div>
                    </div>
                    <div v-else-if="leilao.leilao_1_modalidade != 'venda'" style="position: absolute; float: left; bottom: 60px; left: 0px">
                      <span class="left badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                        Lance inicial: R$ {{ toCurrency(getValorAtual(lote)) }}
                      </span>
                    </div>
                  </div>

                  <i
                    v-if="fotos && fotos.length > 1"
                    class="fa-solid fa-angles-right ic"
                    style="cursor: pointer; font-size: 25px; float: right; position: absolute; top: 45%; right: 0px; padding-right: 5px"
                    @click="proximaFoto(indice_atual + 1)"
                  ></i>

                  <i
                    v-if="fotos && fotos.length > 1"
                    class="fa-solid fa-angles-left ic"
                    style="cursor: pointer; font-size: 25px; float: left; position: absolute; top: 45%; left: 0px; padding-left: 5px"
                    @click="fotoAnterior(indice_atual - 1)"
                  ></i>

                  <!-- LISTAR FOTOS GALERIA FOTOS -->
                  <div class="col-12 product-image-thumbs" style="max-height: 50px">
                    <div
                      v-if="fotos && fotos.length > 1"
                      class="product-image-thumb"
                      :class="indice == indice_atual ? 'img-t' : ''"
                      v-for="(foto, indice) in fotos_paginadas"
                      :key="foto"
                      :value="foto"
                      @click="selecionarFoto(foto, indice), paginarFotos(foto.id)"
                      style="cursor: pointer"
                    >
                      <img :src="getImageThumb(foto)" style="max-height: 40px" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <div class="card card-solid" v-else>
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-sm-12" style="background-color: white">
                  <div class="col-12" style="max-height: 350px; min-width: 300px; text-align: center">
                    <img
                      src="/images/logo.png"
                      class="product-image"
                      style="cursor: pointer; object-fit: scale-down; max-width: 450px; max-height: 190px; padding: 30px 30px 30px 30px"
                      @click="openGallery()"
                    />

                    <!-- TAGS DE STATUS QUANDO JÁ TEM A TAG DESOCUPADO-->
                    <div style="position: absolute; float: right; top: 0px; right: 5px" v-if="lote.lote_situacao == 'desocupado'">
                      <span class="right badge badge-success" style="text-transform: uppercase; font-size: 18px">Desocupado</span>

                      <div style="position: absolute; float: right; top: 0px; right: 145px">
                        <span
                          class="right badge badge-success"
                          style="text-transform: uppercase; font-size: 18px; background-color: red !important"
                          v-if="lote.lote_status == 'retirado'"
                        >
                          Lote retirado
                        </span>

                        <span
                          class="right badge badge-success"
                          style="text-transform: uppercase; font-size: 18px"
                          v-if="lote.lote_status == 'vendido'"
                        >
                          Lote vendido
                        </span>

                        <span
                          class="right badge badge-success"
                          style="text-transform: uppercase; font-size: 18px; background-color: #301904 !important"
                          v-if="lote.lote_status == 'sem_licitante'"
                        >
                          Lote sem licitante
                        </span>
                      </div>
                    </div>

                    <!-- TAGS SEM  STATUS DESOCUPADO-->
                    <div style="position: absolute; float: right; top: 0px; right: 5px" v-else>
                      <span class="right badge badge-success" style="text-transform: uppercase; font-size: 18px" v-if="lote.lote_status == 'vendido'">
                        Lote vendido
                      </span>

                      <span
                        class="right badge badge-success"
                        style="text-transform: uppercase; font-size: 18px; background-color: #301904 !important"
                        v-if="lote.lote_status == 'sem_licitante'"
                      >
                        Lote sem licitante
                      </span>

                      <span
                        class="right badge badge-success"
                        style="text-transform: uppercase; font-size: 18px; background-color: red !important"
                        v-if="lote.lote_status == 'retirado'"
                      >
                        Lote retirado
                      </span>
                    </div>

                    <!-- TAGS LANCE -->
                    <div style="position: absolute; float: left; top: 0px; left: 0px; text-align: left" v-if="lote.lote_lance > 0">
                      <span class="left badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                        Maior lance: R$ {{ toCurrency(lote.lote_lance) }}
                      </span>
                      <div v-if="lote.user">
                        <span class="right badge badge-danger" style="background-color: #4a4949; font-size: 18px">
                          {{ getApelidoFormatado(lote.user.apelido) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </section>
        <div class="card" style="text-align: left">
          <div class="card-body" style="padding-top: 0px; padding-bottom: 0px; font-family: 'Montserrat', sans-serif">
            <div class="row">
              <section class="col-3 col-sm-3 col-md-3" style="text-align: center; background-color: white; justify-content: center">
                <span style="display: inline-block; height: 100%; vertical-align: middle"></span>
                <img :src="getImagePath(leilao)" style="width: 100%; vertical-align: middle" />
              </section>
              <section class="col-9 col-sm-9 col-md-9" style="line-height: 15px !important">
                <div class="row" style="margin-top: 7px">
                  <div class="col-12 col-sm-12 col-md-3">
                    <p style="color: #696969; font-size: 16px">
                      <b>Modalidade:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p style="color: #696969; font-size: 16px">
                      <span v-if="leilao.leilao_1_modalidade == 'venda'">VENDA DIRETA</span>
                      <span v-else style="text-transform: uppercase">{{ leilao.leilao_1_modalidade }}</span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-3">
                    <p style="color: #696969; font-size: 16px">
                      <b>Local:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p style="color: #696969; font-size: 16px; text-transform: uppercase">
                      {{ leilao.leilao_local }}
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-3" v-if="lote.processo">
                    <p style="color: #696969; font-size: 16px"><b>Processo:</b></p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9" v-if="lote.processo">
                    <p style="color: #696969; font-size: 16px">{{ lote.processo.processo_numero }}</p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-3" v-if="leilao.comitente">
                    <p style="color: #696969; font-size: 16px"><b>Comitente:</b></p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9" v-if="leilao.comitente">
                    <p style="color: #696969; font-size: 16px">
                      <span style="font-weight: 500; color: #696969; text-transform: uppercase">{{ getComitente(lote) }}</span>
                      <!--
                      {{ lote.processo.processo_vara }}
                      <a v-if="lote.processo.cidade" style="font-weight: 500; color: #696969">- {{ lote.processo.cidade.nome }}&nbsp;</a>
                      <a v-if="lote.processo.estado" style="font-weight: 500; color: #696969">- {{ lote.processo.estado.sigla }}</a>
                      -->
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-3">
                    <p style="color: #696969; font-size: 16px"><b>Leilão ID:</b></p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p style="color: #696969; font-size: 16px">
                      <span style="font-weight: 500; color: #696969">{{ leilao.id }}</span>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-3">
                    <p style="color: #696969; font-size: 16px">
                      <b>Avaliação:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p style="color: #696969; font-size: 16px">R$ {{ toCurrency(lote.lote_avaliacao) }}</p>
                  </div>
                </div>

                <!-- DATAS E VALORES-->
                <div
                  class="row"
                  v-if="leilao.leilao_num_pracas > 1 && !venda_direta"
                  style="margin-bottom: 7px; border-bottom: none; text-align: left"
                >
                  <!-- PRAÇA 1-->
                  <div class="col-12 col-sm-12 col-md-3">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      <b>1º Leilão:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <span
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                    </span>
                    <span style="color: #696969" v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 1">&nbsp;- VENDIDO</span>
                  </div>

                  <!-- PRAÇA 2-->
                  <div class="col-12 col-sm-12 col-md-3" v-if="leilao.leilao_num_pracas >= 2">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_2_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      <b>2º Leilão:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9" v-if="leilao.leilao_num_pracas >= 2">
                    <span
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_2_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      {{ formatDate(leilao.leilao_2_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_2) }}
                    </span>

                    <span style="color: #696969" v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 2">&nbsp;- VENDIDO</span>
                  </div>

                  <!-- PRAÇA 3-->
                  <div class="col-12 col-sm-12 col-md-3" v-if="leilao.leilao_num_pracas >= 3">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_3_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      <b>3º Leilão:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9" v-if="leilao.leilao_num_pracas >= 3">
                    <span
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_3_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      {{ formatDate(leilao.leilao_3_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_3) }}
                    </span>
                    <span style="color: #696969" v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 3">&nbsp;- VENDIDO</span>
                  </div>

                  <!-- PRAÇA 4-->
                  <div class="col-12 col-sm-12 col-md-3" v-if="leilao.leilao_num_pracas >= 4">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_4_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      <b>4º Leilão:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9" v-if="leilao.leilao_num_pracas >= 4">
                    <span
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_4_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      {{ formatDate(leilao.leilao_4_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_4) }}
                    </span>
                    <span style="color: #696969" v-if="lote.lote_status == 'vendido' && lote.lote_lance_praca == 4">&nbsp;- VENDIDO</span>
                  </div>
                </div>

                <!-- ÚNICO LEILÃO-->
                <div
                  class="row"
                  v-else-if="leilao.leilao_num_pracas == 1 && !venda_direta"
                  style="border-bottom: none; text-align: left"
                  :style="lote.lances == 0 ? 'margin-bottom: 7px' : ''"
                >
                  <div class="col-12 col-sm-12 col-md-3">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      <b>Único leilão:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - R$ {{ toCurrency(lote.lote_valor_1) }}
                    </p>
                  </div>
                </div>

                <!-- DISPONÍVEL ATÉ-->
                <div
                  class="row"
                  v-else-if="venda_direta"
                  style="border-bottom: none; text-align: left"
                  :style="lote.lances == 0 ? 'margin-bottom: 7px' : ''"
                >
                  <div class="col-12 col-sm-12 col-md-3">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      <b>Disponível até:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p
                      style="color: #696969; font-size: 16px"
                      :class="leilao.leilao_1_realizado === 1 || lote.lote_status == 'retirado' || leilao.leilao_retirado == 1 ? 'realizado' : ''"
                    >
                      {{ formatDate(leilao.leilao_1_data) + "h" }} - Pelo valor de: R$ {{ toCurrency(lote.lote_valor_1) }}
                    </p>
                  </div>
                </div>

                <!-- LANCES -->
                <div class="row" v-if="lote.lances > 0 && leilao.leilao_1_modalidade != 'venda'" style="border-bottom: none; text-align: left; margin-bottom: 7px">
                  <div class="col-12 col-sm-12 col-md-3">
                    <p style="color: #696969; font-size: 16px">
                      <b>Qtd. de lances:</b>
                    </p>
                  </div>
                  <div class="col-12 col-sm-12 col-md-9">
                    <p style="color: #696969; font-size: 16px">
                      {{ lote.lances }}
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div class="card" style="text-align: left">
          <div class="card-header" style="color: #4a4949; background-color: white !important; font-weight: bold">DESCRIÇÃO DO LOTE:</div>
          <div class="card-body" style="padding: 12px 12px 12px 12px; font-family: 'Montserrat', sans-serif">
            <span v-html="lote.lote_descricao"></span>
          </div>
        </div>
        <div class="card" style="text-align: left" v-if="lote.lote_info_adicional">
          <div class="card-header" style="color: #4a4949; background-color: white !important; font-weight: bold">INFORMAÇÕES ADICIONAIS:</div>
          <div class="card-body" style="padding: 12px 12px 12px 12px; font-family: 'Montserrat', sans-serif">
            <span v-html="lote.lote_info_adicional"></span>
          </div>
        </div>
      </section>
      <section class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="tab-content p-0" style="line-height: 7px; font-size: 20px">
              <div v-if="!venda_direta">
                <button
                  v-if="show_habilitacao"
                  @click="checkHabilitacao"
                  class="btn btn-success btn-flat"
                  style="border-radius: 7px; width: 100%; font-weight: bold; margin-bottom: 5px"
                  :style="btn_habilitacao_style"
                >
                  <i class="fa fa-check"></i>
                  PEDIR HABILITAÇÃO
                </button>

                <!-- AGUARDANDO LIBERAÇÃO -->
                <button
                  v-if="show_aguardando_habilitacao"
                  @click="aguardandoLiberacao"
                  class="btn btn-warning btn-flat"
                  style="border-radius: 7px; width: 100%; font-weight: bold; color: black; margin-bottom: 5px"
                >
                  AGUARDANDO LIBERAÇÃO
                </button>

                <!-- PENDÊNCIA AGUARDANDO -->
                <div
                  class="card"
                  style="color: black; margin-top: 5px; margin-bottom: 5px; background-color: rgb(219, 181, 10) !important"
                  v-if="habilitacao && habilitacao.motivo_pendencia && show_aguardando_habilitacao"
                >
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    <b style="margin-left: 3px; font-size: 18px">Motivo pendência:</b>
                    <br />
                    <br />
                    <p style="margin-top: 5px; font-size: 18px; line-height: 18px">{{ habilitacao.motivo_pendencia }}</p>
                  </div>
                </div>

                <!-- HABILITAÇÃO BLOQUEADA -->
                <button
                  v-if="show_habilitacao_bloqueada"
                  class="btn btn-danger-red btn-flat"
                  style="border-radius: 7px; width: 100%; font-weight: bold; margin-bottom: 5px"
                >
                  HABILITAÇÃO BLOQUEADA
                </button>

                <!-- PENDÊNCIA BLOQUEIO -->
                <div
                  class="card"
                  style="margin-top: 5px; margin-top: 5px; margin-bottom: 5px; background-color: #dc3545 !important; color: white"
                  v-if="habilitacao && habilitacao.motivo_bloqueio && show_habilitacao_bloqueada"
                >
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    <b style="margin-left: 3px; font-size: 18px">Motivo bloqueio:</b>
                    <br />
                    <br />
                    <p style="margin-top: 5px; font-size: 18px; line-height: 18px">{{ habilitacao.motivo_bloqueio }}</p>
                  </div>
                </div>

                <button
                  v-if="show_auditorio_btn"
                  @click="checkIsHabilitado"
                  class="btn btn-success btn-flat"
                  style="border-radius: 7px; width: 100%; font-weight: bold; margin-bottom: 5px"
                >
                  <i style="margin-right: 5px" class="fa-solid fa-right-to-bracket"></i>
                  IR PARA O AUDITÓRIO
                </button>
              </div>

              <div v-if="!ocultar_btn_proposta">
                <!-- ENVIAR PROPOSTA COMPRA -->
                <button
                  v-if="venda_direta"
                  class="btn btn-success btn-flat"
                  style="border-color: #a6db65; background-color: #a6db65; width: 100%; border-radius: 7px; font-weight: bold; margin-bottom: 5px"
                  @click="validarEnviarPropostaCompra()"
                  :style="btn_proposta_compra_style"
                >
                  <i class="fa-solid fa-comments-dollar"></i>
                  ENVIAR PROPOSTA COMPRA
                </button>

                <!-- APENAS ENVIAR PROPOSTA #6bb314; -->
                <button
                  v-if="!venda_direta && lote.lote_permitir_parcelamento == 1"
                  class="btn btn-success btn-flat"
                  style="border-color: #a6db65; background-color: #a6db65; width: 100%; border-radius: 7px; font-weight: bold; margin-bottom: 5px"
                  @click="validarEnviarProposta()"
                  :style="btn_proposta_parcelamento_style"
                >
                  <i class="fa-solid fa-comments-dollar"></i>
                  ENVIAR PROPOSTA PARCELAMENTO
                  <span class="right badge badge-secondary" v-if="propostas && propostas.length">{{ propostas.length }}</span>
                </button>
              </div>

              <!-- PROPOSTAS ENVIADAS -->
              <button
                v-if="propostas"
                v-for="proposta in propostas"
                :key="proposta"
                :value="proposta"
                class="btn btn-success btn-flat"
                style="
                  cursor: context-menu;
                  margin-left: 15%;
                  width: 85%;
                  background-color: #a6db65;
                  border-color: #a6db65;
                  border-radius: 7px;
                  font-weight: bold;
                  padding-top: 5px;
                  margin-bottom: 5px;
                  padding: 5px 5px 5px 5px;
                  position: relative;
                "
              >
                <!--<span style="color: #6c6e6a" v-if="proposta.deleted_at">Revogada em {{ formatDate(proposta.deleted_at) }}</span>-->
                <span
                  v-if="proposta.tipo == 'venda'"
                  style="color: #6c6e6a; cursor: pointer"
                  @click="(proposta_selecionada = proposta), (visualizar_proposta = true)"
                  data-toggle="modal"
                  data-target="#visualizar-modal"
                >
                  {{ getNomePropostaFormatado(proposta) }}
                </span>

                <span
                  v-else
                  style="color: #6c6e6a; cursor: pointer; font-size: 14px"
                  @click="(proposta_selecionada = proposta), (visualizar_proposta = true)"
                  data-toggle="modal"
                  data-target="#visualizar-modal"
                >
                  {{ proposta.praca + "º PRAÇA - " + toCurrency(proposta.valor_proposta) }}
                  <br />
                  {{ getNomePropostaFormatado(proposta) }}
                </span>

                <button
                  style="background-color: #a6db65; border-color: #a6db65; margin-left: 5px; margin-bottom: 1px"
                  type="button"
                  class="btn btn-default btn-sm"
                  @click="deletarProposta(proposta)"
                >
                  <i class="fa fa-trash" style="color: red"></i>
                </button>

                <div style="position: absolute; float: right; top: -10px; right: 5px">
                  <span v-if="proposta.deleted_at" class="right badge badge-secondary" style="font-size: 9px">Revogada</span>
                </div>
              </button>

              <button
                v-for="edital in editais_leilao"
                class="btn btn-danger btn-flat"
                style="border-radius: 7px; width: 100%; background-color: #783a13; border-color: #783a13; font-weight: bold; margin-bottom: 5px"
                @click="getEdital(edital)"
              >
                <i class="fa-solid fa-file-pdf"></i>
                <!-- EDITAL (GERAL) -->
                EDITAL
              </button>
              <button
                v-for="edital in editais"
                class="btn btn-danger btn-flat"
                style="border-radius: 7px; width: 100%; background-color: #783a13; border-color: #783a13; font-weight: bold; margin-bottom: 5px"
                @click="getEdital(edital)"
              >
                <i class="fa-solid fa-file-pdf"></i>
                <!-- EDITAL ({{ edital.tipo }}) -->
                EDITAL
              </button>
              <button
                v-if="possui_edital_documento"
                class="btn btn-danger btn-flat"
                style="border-radius: 7px; width: 100%; background-color: #783a13; border-color: #783a13; font-weight: bold; margin-bottom: 5px"
                @click="getEditalDocumento('documento')"
              >
                <i class="fa-solid fa-file-pdf"></i>
                EDITAL
              </button>
              <a
                v-for="documento in documentos"
                :key="documento"
                :value="documento"
                class="btn btn-default btn-flat"
                style="
                  border-radius: 7px;
                  width: 100%;
                  font-weight: bold;
                  font-size: 15px;
                  background-color: #aa7c39;
                  border-color: #aa7c39;
                  color: white;
                  margin-bottom: 5px;
                  text-transform: uppercase;
                "
                :href="getLink(documento)"
                target="_blank"
              >
                {{ documento.nome }}
              </a>
              <br />
              <button
                class="btn btn-info btn-flat"
                style="border-radius: 7px; width: 100%; font-weight: bold"
                data-toggle="modal"
                data-target="#contato-modal"
                @click="show_contato = true"
              >
                <i class="fa fa-envelope"></i>
                CONTATO
              </button>
              <br />
              <br />
              <button @click="compartilharWhatsApp" class="btn btn-secondary btn-success" style="border-radius: 7px; width: 100%; font-weight: bold">
                <i class="fa-brands fa-whatsapp"></i>
                COMPARTILHAR
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- MODAL VISUALIZAR PROPOSTA -->
    <div
      class="modal fade"
      id="visualizar-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      style="margin-top: 30px"
      v-if="visualizar_proposta"
      @click.self="visualizar_proposta = false"
    >
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="visualizar_proposta = false">&times;</button>
              <h4>Proposta enviada</h4>
              <br />
              <div class="p-2">
                <proposta :proposta="proposta_selecionada" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- ENVIAR PROPOSTA MODAL -->
    <enviar-proposta
      :propostas="propostas"
      v-if="enviar_proposta"
      :lote="lote"
      :leilao="leilao"
      :user="user"
      :setEnviarProposta="setEnviarProposta"
      :propostaEnviada="propostaEnviada"
    />

    <!-- ENVIAR PROPOSTA COMPRA MODAL -->
    <enviar-proposta-compra
      :user="user"
      :propostas="propostas"
      v-if="enviar_proposta_compra"
      :lote="lote"
      :leilao="leilao"
      :setEnviarPropostaCompra="setEnviarPropostaCompra"
      :propostaEnviada="propostaEnviada"
    />

    <div class="modal fade" id="image-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="background-color: #4a4949">
          <div class="modal-body">
            <button id="close_btn" type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <img
              style="position: relative; max-height: 700px; object-fit: contain"
              :src="getImageFoto(foto_selecionada)"
              class="product-image im"
              :alt="foto_selecionada.alt"
            />
            <i
              class="fa-solid fa-angles-right ic"
              style="color: white; cursor: pointer; font-size: 25px; float: right; position: absolute; top: 45%; right: 0px; padding-right: 5px"
              @click="proximaFoto(indice_atual + 1)"
            ></i>

            <i
              class="fa-solid fa-angles-left ic"
              style="color: white; cursor: pointer; font-size: 25px; float: left; position: absolute; top: 45%; left: 0px; padding-left: 5px"
              @click="fotoAnterior(indice_atual - 1)"
            ></i>

            <!-- LISTAR FOTOS GALERIA FOTOS -->
            <div class="col-12 product-image-thumbs" style="max-height: 50px">
              <div
                class="product-image-thumb"
                :class="indice == indice_atual ? 'img-t' : ''"
                v-for="(foto, indice) in fotos_paginadas"
                :key="foto"
                :value="foto"
                @click="selecionarFoto(foto, indice), paginarFotos(foto.id)"
                style="cursor: pointer"
              >
                <img :src="getImageFoto(foto)" style="max-height: 40px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="documentos-modal" tabindex="-1" role="dialog" aria-labelledby="documentosModal" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="background-color: #4a4949">
          <div class="modal-body">
            <a
              v-for="documento in lote.documentos"
              :key="documento"
              :value="documento"
              class="btn btn-default btn-flat"
              style="border-radius: 7px; width: 100%; font-weight: bold; font-size: 13px"
              :href="getLink(documento)"
              target="_blank"
            >
              <i class="fa-solid fa-download" style="margin-right: 5px"></i>
              {{ documento.nome }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="habilitacao-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h4>Solicitar habilitação</h4>
          <br />
          <div class="row">
            <!-- NOME -->
            <div class="col-sm-12">
              <div class="form-group">
                <label>Uma habilitação é necessária para poder participar deste leilão. Por favor, solicite a sua habilitação.</label>
                <br />
                <br />
                <a href="/termos-leiloes-eletronicos">Clique aqui para visualizar os termos de uso.</a>

                <br />
                <input type="checkbox" id="agreeTerms" name="terms" value="agree" v-model="formData.termos" />
                &nbsp;&nbsp; Eu li e concordo com os termos de uso para participação do leilão eletrônico.

                <br />
                <span style="color: red" v-for="error in v$.termos.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>

              <button type="submit" class="btn btn-primary" @click="validateFields()" style="margin-right: 15px">Solicitar habilitação</button>

              <button data-toggle="modal" id="cancelar" data-target="#habilitacao-modal" class="btn btn-danger">Voltar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL EDITAL -->
  <div
    class="modal fade"
    id="exibir-edital-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="imageModal"
    aria-hidden="true"
    v-if="documento_edital"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="padding: 1px 0px 1px 0px">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="margin-right: 10px">&times;</button>
          <h4 style="margin-left: 10px">Edital</h4>

          <div class="card-body">
            <div class="tab-content p-0">
              <!-- <object v-if="documento_edital.ext == 'pdf'" :data="getPathEdital()" type="application/pdf" width="100%" height="600px"></object> -->
              <iframe
                v-if="documento_edital.ext === 'pdf' || file_type == 'PDF'"
                :src="getPathEdital()"
                type="application/pdf"
                width="100%"
                height="600px"
                style="border: none"
              ></iframe>

              <span v-else-if="documento_edital.ext == 'html'" v-html="documento_edital.html"></span>
              <img v-else :src="getPathEdital()" />
            </div>
          </div>

          <button
            data-toggle="modal"
            data-target="#exibir-edital-modal"
            id="close_edital_modal"
            style="margin-left: 5px; margin-bottom: 5px"
            type="button"
            class="btn btn-info btn-sm"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL LISTAR PROPOSTAS -->
  <div class="modal fade" id="listar-propostas-modal" tabindex="-1" role="dialog" aria-labelledby="imageModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body" style="padding: 1px 0px 1px 0px">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="margin-right: 10px">&times;</button>
          <h4 style="margin-left: 10px">Propostas</h4>
          <table class="table table-hover" v-if="propostas" style="border: 2px solid; border-color: gray; font-weight: bold">
            <thead>
              <tr>
                <th>Data de envio</th>
                <th>Leilão</th>
                <th>Valor proposta</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(proposta, index) in propostas" :key="habilitacao">
                <td data-label="Data">
                  {{ formatDate(proposta.created_at) }}
                </td>
                <td data-label="Leilão">
                  <div>
                    <b>Leilão:&nbsp;</b>
                    <span style="font-weight: 500">{{ proposta.leilao_id }} - {{ getFormatedTitle(proposta.leilao_titulo) }}</span>
                  </div>
                  <div>
                    <b>Lote:&nbsp;</b>
                    <span style="font-weight: 500">{{ proposta.lote_numero }} - {{ getFormatedTitle(proposta.lote_titulo) }}</span>
                  </div>
                  <div>
                    <b>Praça:&nbsp;</b>
                    <span style="font-weight: 500">{{ proposta.praca }}</span>
                  </div>
                </td>
                <td data-label="Valor">R$ {{ toCurrency(proposta.valor_proposta) }}</td>
                <td>
                  <a :href="'/proposta/' + proposta.hash" style="width: 100%" target="_blank" type="button" class="btn btn-primary btn-sm">
                    Visualizar
                  </a>
                  <button style="margin-top: 5px; width: 100%" @click="revogar(proposta)" type="button" class="btn btn-danger btn-sm">Revogar</button>
                </td>
              </tr>
            </tbody>
          </table>

          <button
            data-toggle="modal"
            data-target="#listar-propostas-modal"
            id="close_propostas_modal"
            style="margin-left: 5px; margin-bottom: 5px"
            type="button"
            class="btn btn-info btn-sm"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>

  <modal-contato :user="user" v-if="show_contato" :pre_assunto="getPre(pre_assunto)" />
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao";
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import currencyController from "../../controller/currencyController";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import useVueLidate from "@vuelidate/core";
import { computed, reactive } from "vue";
import { helpers } from "@vuelidate/validators";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController, auxFormatacao],

  props: ["propostas", "lote", "leilao", "fotos", "user", "habilitacao", "count_lotes"],

  components: { Loading },

  setup() {
    const formData = reactive({
      termos: false,
    });

    const rules = computed(() => {
      return {
        termos: { aceitarTermos: helpers.withMessage(" Você precisa aceitar os termos de uso", aceitarTermos) },
      };
    });

    const aceitarTermos = (value) => {
      return value;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      foto_selecionada: "",
      indice_atual: 0,
      documentos: [],
      venda_direta: false,
      isLoading: false,
      show_contato: false,
      show_habilitacao: false,
      show_habilitacao_bloqueada: false,
      show_aguardando_habilitacao: false,
      show_auditorio_btn: false,
      enviar_proposta: false,
      enviar_proposta_compra: false,
      user_habilitado: false,
      show_proposta_parcelamento_btn: false,
      proposta_selecionada: "",
      visualizar_proposta: "",
      proposta_formatada: {},
      user_profile: "",
      documento_edital: "",
      btn_habilitacao_style: "",
      btn_proposta_parcelamento_style: "",
      btn_proposta_compra_style: "",
      fotos_paginadas: [],
      foto_atual: "",
      possui_edital_documento: false,
      possui_edital_publicado: false,
      possui_edital_anexo: false,
      editais: "",
      editais_leilao: "",
      pracas_fechadas: false,
      ocultar_btn_proposta: false,
    };
  },

  mounted() {
    //console.log("Detalhes");
    /*
    console.log(this.user);
    console.log(this.user.role);
    console.log(this.propostas);
    console.log(this.lote);
    console.log(this.leilao);
    */

    console.log(this.lote);

    //VERIFICANDO SE POSSUI EDITAL
    if (this.lote.processo && this.lote.processo.publicacao) {
      this.possui_edital_publicado = true;

      this.documento_edital = {
        ext: "html",
        titulo: this.lote.processo.publicacao.titulo,
        html: this.lote.processo.publicacao.conteudo,
      };
    }

    if (this.leilao.edital) {
      //console.log("Documento edital");
      //console.log(this.leilao.edital);

      this.possui_edital_documento = true;
      this.documento_edital = this.leilao.edital;
    }

    //console.log("Documento edital");
    //console.log(this.documento_edital);
    /*
    if (
      this.leilao.leilao_1_modalidade == "venda" ||
      this.leilao.leilao_2_modalidade == "venda" ||
      this.leilao.leilao_3_modalidade == "venda" ||
      this.leilao.leilao_4_modalidade == "venda" ||
      this.leilao.leilao_retirado == 1 ||
      this.leilao.leilao_oculto == 1 ||
      this.leilao.leilao_suspenso == 1 ||
      this.leilao.leilao_pausado == 1
    ) {
      this.show_habilitacao = false;
    } else if (this.user) {
      if (this.user.status == "liberado") {
        if (!this.habilitacao) {
          this.show_habilitacao = true;
        } else if (this.habilitacao.status == "aguardando") {
          this.show_aguardando_habilitacao = true;
        } else if (this.habilitacao.status == "bloqueado") {
          this.show_habilitacao_bloqueada = true;
        } else if (this.habilitacao.status == "liberado") {
          this.show_auditorio_btn = true;
          this.user_habilitado = true;
        }
      }
    } else {
      this.show_habilitacao = true;
    }
      */

    //VALIDAÇÕES BOTÕES

    if (this.lote.lote_oculto == 1 || this.lote.lote_status == "vendido" || this.lote.lote_status == "retirado") {
      this.ocultar_btn_proposta = true;
    }

    //STATUS LEILÃO + MODALIDADE
    if (
      this.leilao.leilao_1_modalidade == "venda" ||
      this.leilao.leilao_2_modalidade == "venda" ||
      this.leilao.leilao_3_modalidade == "venda" ||
      this.leilao.leilao_4_modalidade == "venda" ||
      this.leilao.leilao_retirado == 1 ||
      this.leilao.leilao_oculto == 1 ||
      this.leilao.leilao_suspenso == 1 ||
      this.leilao.leilao_pausado == 1 ||
      this.leilao.leilao_encerrado == 1
    ) {
      this.show_auditorio_btn = false;
      this.show_habilitacao = false;
      this.btn_proposta_parcelamento_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
      console.log("condition1");
    } else if (this.user) {
      if ((this.user && this.user.profile && this.user.profile.magistrado) || (this.user && this.user.role == "admin")) {
        this.show_habilitacao = false;
        this.show_auditorio_btn = true;

        console.log("condition2");
      } else if (this.user.status == "liberado") {
        console.log("condition3");
        if (!this.habilitacao) {
          this.show_habilitacao = true;
        } else if (this.habilitacao.status == "aguardando") {
          this.show_aguardando_habilitacao = true;
        } else if (this.habilitacao.status == "bloqueado") {
          this.show_habilitacao_bloqueada = true;
        } else if (this.habilitacao.status == "liberado") {
          this.show_auditorio_btn = true;
          this.user_habilitado = true;
        }
      }
    } else {
      this.btn_habilitacao_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
      this.show_habilitacao = true;
      this.show_auditorio_btn = false;
    }

    //SOMENTE STATUS LEILÃO
    if (
      this.leilao.leilao_retirado == 1 ||
      this.leilao.leilao_oculto == 1 ||
      this.leilao.leilao_suspenso == 1 ||
      this.leilao.leilao_pausado == 1 ||
      this.leilao.leilao_encerrado == 1
    ) {
      this.btn_proposta_compra_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
    }

    //NÃO VALIDA LEILÃO MODALIDADE OU SUSPENSO
    if (!this.user) {
      this.show_proposta_parcelamento_btn = true;
      this.btn_proposta_parcelamento_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
      this.btn_proposta_compra_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
    } else {
      if (this.user_habilitado && this.lote.lote_permitir_parcelamento == 1 && this.leilao.leilao_1_modalidade != "venda") {
        this.show_proposta_parcelamento_btn = true;
      }

      if (this.user.status != "liberado" || (this.habilitacao && this.habilitacao.status != "liberado")) {
        this.btn_proposta_parcelamento_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
        this.btn_proposta_compra_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
      }
    }

    if (
      this.lote.lote_status == "vendido" ||
      this.lote.lote_status == "suspenso" ||
      this.lote.lote_status == "vendido_condicional" ||
      this.lote.lote_status == "retirado"
    ) {
      this.btn_proposta_parcelamento_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
      this.btn_proposta_compra_style = "background-color: #6c757d !important; border-color:  #6c757d !important";
    }

    if (this.fotos && this.fotos.length) {
      this.foto_selecionada = this.fotos[0];
    }

    this.venda_direta =
      this.leilao.leilao_1_modalidade == "venda" ||
      this.leilao.leilao_2_modalidade == "venda" ||
      this.leilao.leilao_3_modalidade == "venda" ||
      this.leilao.leilao_4_modalidade == "venda";

    //DOCUMENTOS DO LEILÃO
    for (let i = 0; i < this.lote.documentos.length; i++) {
      this.documentos.push(this.lote.documentos[i]);
    }

    //DOCUMENTOS DO LOTE
    for (let i = 0; i < this.leilao.documentos.length; i++) {
      let indice = this.findDoc(this.leilao.documentos[i].id);

      if (indice < 0) {
        this.documentos.push(this.leilao.documentos[i]);
      }
    }

    //ALFABÉTICO
    this.documentos.sort(function (a, b) {
      if (a.nome < b.nome) {
        return -1;
      }
      if (a.nome > b.nome) {
        return 1;
      }
      return 0;
    });

    //ORDEM
    this.documentos.sort((a, b) => a.ordem - b.ordem);

    //PAGINAÇÃO FOTOS
    let tamanho_maximo = this.fotos.length < 12 ? this.fotos.length : 12;

    //console.log("MAX FOTOS");
    //console.log(tamanho_maximo);
    //console.log(this.fotos.length);

    for (let i = 0; i < tamanho_maximo; i++) {
      this.fotos_paginadas.push(this.fotos[i]);
    }

    this.buscarEditais();
    this.buscarEditaisLeiloes();
  },

  methods: {
    voltar() {
      const urlParams = new URLSearchParams(window.location.search);
      let filter = urlParams.get("origin");

      if (filter) {
        if (filter == "agenda") {
          window.open("/agenda", "_self");
        }
      } else {
        history.back();
      }
    },

    getValorAtual(lote) {
      //PRAÇA ATUAL
      if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
        return lote.lote_valor_1;
      } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
        return lote.lote_valor_2;
      } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
        return lote.lote_valor_3;
      } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
        return lote.lote_valor_4;
      } else {
        this.pracas_fechadas = true;
        return null;
      }
    },

    buscarEditaisLeiloes() {
      let data = {
        leilao_id: this.leilao.id,
        inicio: 0,
        tamanho: 10000,
      };

      //console.log("Buscando editais leilao");
      //console.log(data);

      axios
        .post(`/editais/find_by_leilao`, data)
        .then((response) => {
          this.editais_leilao = response.data.editais;

          console.log("Editais leilao listados");
          console.log(this.editais);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarEditais() {
      let data = {
        lote_id: this.lote.id,
        inicio: 0,
        tamanho: 10000,
      };

      console.log("Buscando editais");
      console.log(data);

      axios
        .post(`/editais/find_by_lote`, data)
        .then((response) => {
          this.editais = response.data.editais;

          console.log("Editais listados");
          console.log(this.editais);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    compartilharWhatsApp() {
      const urlAtual = encodeURIComponent(window.location.href);
      let mensagem = encodeURIComponent(
        `Acabei de encontrar isso no site da Rocha Leilões: Muito interessante!\nLeilão: ` +
          this.leilao.id +
          " - " +
          this.leilao.leilao_titulo +
          "\nLote: " +
          this.lote.lote_numero +
          " - " +
          this.lote.lote_titulo +
          "\n"
      );

      let data = {
        leilao_id: this.leilao.id,
        lote_id: this.lote.id,
      };

      axios
        .post(`/user/lotes/share`, data)
        .then((response) => {
          mensagem = mensagem + urlAtual;
          const url = `https://api.whatsapp.com/send?text=${mensagem}`;
          window.open(url, "_blank");
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    paginarFotos(foto_id) {
      let index = this.fotos.findIndex((element) => element["id"] == foto_id);

      console.log("Atual " + index);

      this.fotos_paginadas = [];

      this.foto_atual = index + 1;
      let length = this.fotos.length;
      let i = 0;

      if (length < 0) {
        length = 0;
      } else if (length > 12) {
        if (this.foto_atual >= 8) {
          console.log("IF 01");
          //SUBTRAIR A QUANTIDADE QUE DESEJA EXIBIR ANTES
          let minimo = this.foto_atual - 7;

          if (length - this.foto_atual > 6) {
            console.log("IF 02");
            length = this.foto_atual + 6;
            i = minimo;
          } else {
            console.log("else IF 02");
            //SUBTRAIR A QUANTIDADE QUE DESEJA EXIBIR ANTES + 8
            i = this.foto_atual - 13 + (length - this.foto_atual);
          }
        } else {
          console.log("Else 2");
          length = 12;
        }
      } else {
        console.log("Direto no else");
      }

      console.log("Valor I= " + i);
      console.log("Lenght " + length);
      console.log("Tamanho fotos original" + this.fotos.length);
      console.log(this.fotos);

      for (i; i < length; i++) {
        this.fotos_paginadas.push(this.fotos[i]);
      }

      index = this.fotos_paginadas.findIndex((element) => element["id"] == foto_id);

      this.indice_atual = index;
    },

    getComitente(lote) {
      let comitente = this.leilao.comitente.nome;

      if (this.leilao.comitente.cidade) {
        if (this.leilao.comitente.cidade.nome) {
          comitente = comitente + " - " + this.leilao.comitente.cidade.nome;
        }

        if (this.leilao.comitente.estado.sigla) {
          comitente = comitente + " - " + this.leilao.comitente.estado.sigla;
        }
      }

      return comitente;

      //ALTERADO EM 05/06/2026
      /*
      let comitente = lote.processo.processo_vara;

      if (lote.processo.cidade) {
        if (lote.processo.cidade.nome) {
          comitente = comitente + " - " + lote.processo.cidade.nome;
        }

        if (lote.processo.estado.sigla) {
          comitente = comitente + " - " + lote.processo.estado.sigla;
        }
      }
      */
      //FIM

      /*
      if (comitente && comitente.length > 80) {
        return comitente.substring(0, 80) + "...";
      } else {
        return comitente;
      }
        */

      return comitente;
    },
    redirectBack() {
      console.log("Lotes?");
      console.log(this.count_lotes);

      if (this.count_lotes && this.count_lotes > 1) {
        window.location.href = "/leilao/" + this.leilao.id + "/lotes";
      } else {
        window.location.href = "/";
      }
    },

    deletarProposta(proposta) {
      this.visualizar_proposta = false;

      console.log("Deletando");
      console.log(proposta);

      this.$swal
        .fire({
          title:
            "<h3 style='color:#616060'>Deseja deletar a proposta <br/><b>" +
            this.getNomePropostaFormatado(proposta) +
            "</b>?<br/> Esta ação é irreversível.</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              form_proposta_id: proposta.id,
            };

            axios
              .post(`/user/proposta/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButtonAndReload("Sucesso", "Proposta deletada!");
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validarEnviarPropostaCompra() {
      let data = {
        leilao_id: this.leilao.id,
        lote_id: this.lote.id,
      };

      axios
        .post(`/user/proposta/check`, data)
        .then((response) => {
          if (response.data.success) {
            if (this.propostas && this.propostas.length > 0) {
              this.$swal
                .fire({
                  title:
                    "<h3 style='color:#616060; font-size: 22px'>Ao enviar uma nova proposta suas propostas anteriores para este lote serão revogadas de forma que exista uma única proposta POR LOTE.<br/>Deseja prosseguir? </h3>",
                  icon: "warning",
                  padding: "1.5em",
                  showCancelButton: true,
                  cancelButtonText: "Cancelar",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Sim, cancelar propostas anteriores!",
                })
                .then((result) => {
                  if (result.value) {
                    this.enviar_proposta_compra = true;
                  }
                });
            } else {
              this.enviar_proposta_compra = true;
            }
          } else {
            console.log(response);
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          let tipo_proposta = "compra";

          let msg =
            tipo_proposta == "parcelamento"
              ? "Para enviar proposta de parcelamento em lote de leilão você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login."
              : "Para enviar proposta de compra você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.";

          this.showErrorMessageWithButtonAndRedirectIfConfirm("Ops...", msg, "/login");
        });
    },

    validarEnviarProposta() {
      let data = {
        leilao_id: this.leilao.id,
        lote_id: this.lote.id,
      };

      axios
        .post(`/user/proposta/check`, data)
        .then((response) => {
          if (response.data.success) {
            if (this.propostas && this.propostas.length > 0 && this.user) {
              this.$swal
                .fire({
                  title:
                    "<h3 style='color:#616060; font-size: 22px'>Ao enviar uma nova proposta suas propostas anteriores para este lote, da mesma praça, serão revogadas de forma que exista apenas uma única proposta POR LOTE e POR PRAÇA.<br/>Deseja prosseguir? </h3>",
                  icon: "warning",
                  padding: "1.5em",
                  showCancelButton: true,
                  cancelButtonText: "Cancelar",
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Sim, cancelar propostas anteriores!",
                })
                .then((result) => {
                  if (result.value) {
                    this.enviar_proposta = true;
                  }
                });
            } else {
              this.enviar_proposta = true;
            }
          } else {
            console.log(response);
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          let tipo_proposta = "parcelamento";

          let msg =
            tipo_proposta == "parcelamento"
              ? "Para enviar proposta de parcelamento em lote de leilão você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login."
              : "Para enviar proposta de compra você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.";

          this.showErrorMessageWithButtonAndRedirectIfConfirm("Ops...", msg, "/login");
        });
    },

    isLogged(tipo_proposta, callback) {
      axios
        .post(`/user/isLogged`)
        .then((response) => {
          callback();
        })
        .catch((error) => {
          let msg =
            tipo_proposta == "parcelamento"
              ? "Para enviar proposta de parcelamento em lote de leilão você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login."
              : "Para enviar proposta de compra você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.";

          this.showErrorMessageWithButtonAndRedirectIfConfirm("Ops...", msg, "/login");
        });
    },

    getNomePropostaFormatado(proposta) {
      if (proposta.tipo == "venda") {
        if (proposta.parcelas > 0) {
          return "Parcelado: " + "R$" + this.toCurrency(proposta.valor_entrada) + "+ " + proposta.parcelas + "x ";
        } else {
          return "R$" + this.toCurrency(proposta.valor_proposta);
        }
      } else {
        let valor_parcela = (proposta.valor_proposta - proposta.valor_entrada) / proposta.parcelas;

        return "Parcelado: " + "R$" + this.toCurrency(proposta.valor_entrada) + "+ " + proposta.parcelas + "x ";
      }
    },

    aguardandoLiberacao() {
      this.showErrorMessageWithButtonAndReload("Ops...", "Aguarde liberação. Clique em OK para atualizar o status da tela.");
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    revogar(proposta) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja cancelar essa proposta?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero cancelar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              form_proposta_id: proposta.id,
            };

            axios
              .post(`/user/proposta/delete`, data)
              .then((response) => {
                this.isLoading = false;

                this.showSuccessMessageWithButtonAndReload("Proposta cancelada!");

                let btn = document.getElementById("close_propostas_modal");

                btn.click();
              })
              .catch((error) => {
                this.isLoading = false;
                console.log(error);

                if (typeof error == "object") {
                  if (error.response.status == "403") {
                    this.showErrorMessageWithButtonAndRedirectIfConfirm("Ops...", "Você precisa estar logado para esta ação.", "/login");
                  } else {
                    this.showErrorMessageWithButton("Ops..", "Houve um problema com a sua solicitação.");
                  }
                } else {
                  this.showErrorMessageWithButtonAndReloadIfConfirm(
                    "Ops..",
                    "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela"
                  );
                }
              });
          }
        });
    },

    propostaEnviada() {
      let btn = document.getElementById("fechar_enviar_proposta");

      btn.click();

      this.setEnviarProposta(false);

      this.buscarCampanhas();
    },

    setEnviarPropostaCompra(value, cancel_click) {
      let btn = document.getElementById("fechar_enviar_proposta_compra");

      if (btn && !cancel_click) {
        //console.log("Clicando agora");
        btn.click();
      }

      this.enviar_proposta_compra = value;
    },

    setEnviarProposta(value, cancel_click) {
      let btn = document.getElementById("fechar_enviar_proposta");

      if (btn && !cancel_click) {
        //console.log("Clicando agora");
        btn.click();
      }

      this.enviar_proposta = value;
    },

    openGallery() {
      //console.log("ABRINDO");

      if (this.fotos && this.fotos.length) {
        let btn = document.getElementById("close_btn");
        btn.click();
      } else {
        this.showErrorMessageWithButton("Ops...", "Este lote não possui fotos.");
      }
    },

    getEditalDocumento() {
      if (this.isDesktop()) {
        let btn = document.getElementById("close_edital_modal");
        btn.click();
      } else {
        let url = "";

        let edital = this.documento_edital;

        if (edital.path.includes("rochaleiloes2")) {
          url = process.env.MIX_VUE_APP_S3_BASE2_URL + edital.path + "/" + edital.file;
        } else if (edital.path.includes("rochaleiloes")) {
          url = process.env.MIX_VUE_APP_S3_BASE_URL + edital.path + "/" + edital.file;
        } else {
          url = process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + edital.path + "/" + edital.file;
        }

        window.open(url, "_blank").focus();
      }
    },

    isDesktop() {
      return window.innerWidth > 768;
    },

    getEdital(edital) {
      //console.log(edital);

      if (edital.tipo == "publicacao") {
        window.open("/" + edital.id + "/publicacao", "_blank").focus();
      } else if (edital.tipo == "anexo") {
        let url = "";

        if (edital.path.includes("rochaleiloes2")) {
          url = process.env.MIX_VUE_APP_S3_BASE2_URL + edital.path + "/" + edital.file;
        } else if (edital.path.includes("rochaleiloes")) {
          url = process.env.MIX_VUE_APP_S3_BASE_URL + edital.path + "/" + edital.file;
        } else {
          url = process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + edital.path + "/" + edital.file;
        }

        window.open(url, "_blank").focus();
      }
    },

    getPathEdital() {
      let url = "";

      if (this.documento_edital.path.includes("rochaleiloes2")) {
        url = process.env.MIX_VUE_APP_S3_BASE2_URL + this.documento_edital.path + "/" + this.documento_edital.file;
      } else if (this.documento_edital.path.includes("rochaleiloes")) {
        url = process.env.MIX_VUE_APP_S3_BASE_URL + this.documento_edital.path + "/" + this.documento_edital.file;
      } else {
        url = process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.documento_edital.path + "/" + this.documento_edital.file;
      }

      return url;
    },

    downloadWithAxios(documento) {
      if (documento) {
        let url = "";

        if (documento.path.includes("rochaleiloes")) {
          url = process.env.MIX_VUE_APP_S3_BASE_URL + documento.path + "/" + documento.file;
        } else {
          url = process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + documento.path + "/" + documento.file;
        }

        let title = documento.nome + "." + documento.ext;

        axios({
          method: "get",
          url,
          responseType: "arraybuffer",
        })
          .then((response) => {
            this.forceFileDownload(response, title, documento.ext);
          })
          .catch(() => console.log("error occured"));
      }
    },

    forceFileDownload(response, title, type) {
      //console.log("Baixando agora");
      //console.log(type);
      //console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: type }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },

    getPre() {
      return "Leilão " + this.leilao.id + " - Lote " + this.lote.lote_numero;
    },

    checkHabilitacao() {
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      //console.log("Busca");
      //console.log(data);

      axios
        .post(`/user/habilitacao/check`, data)
        .then((response) => {
          //console.log(response.data);

          this.isLoading = false;

          if (response.data.success) {
            if (response.data.lote_categoria) {
              this.checkRestricaoCategorias(response.data.lote_categoria);
            } else {
              this.$nextTick(function () {
                document.getElementById("cancelar").click();
              });
            }
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndRedirectIfConfirm(
                "Ops...",
                "Para essa ação você precisa estar logado. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            } else {
              this.showErrorMessageWithButtonAndRedirect(
                "Ops..",
                "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela",
                "/lote/" + this.lote.id
              );
              //this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }
        });
    },

    checkRestricaoCategorias(lote_categoria) {
      let html = "";

      console;

      if (lote_categoria.nome == "Sucatas") {
        html = "Para pedir habilitação em lotes de sucata você precisa ter autorização do Detran. Deseja continuar?";
      }
      if (lote_categoria.nome == "Vagas de Garagem") {
        html = "Para pedir habilitação em lotes de vagas de garagem você precisa ser morador do endereço. Deseja continuar?";
      }

      this.$swal
        .fire({
          title: "Atenção",
          html: html,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim!",
        })
        .then((result) => {
          if (result.value) {
            this.exibir_modal_habilitacao = true;

            this.$nextTick(function () {
              document.getElementById("cancelar").click();
            });
          }
        });
    },

    checkIsHabilitado() {
      this.show_contato = false;

      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      //console.log("Busca");
      //console.log(data);

      axios
        .post(`/user/auditorio/check`, data)
        .then((response) => {
          //console.log(response.data);

          this.isLoading = false;

          if (response.data.habilitado) {
            if (this.user && this.user.role == "admin") {
              window.location.href = "/admin/auditorio_user/" + this.leilao.id;
            } else {
              window.location.href = "/user/auditorio/" + this.leilao.id;
            }
          } else if (response.data.msg) {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", "Favor atualizar a tela.", "/user/habilitacoes");
          }
        })
        .catch((error) => {
          this.isLoading = false;

          if (typeof error == "object") {
            if (error.response.status == "403") {
              this.showErrorMessageWithButtonAndRedirect(
                "Ops...",
                "Para entrar no auditório você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
            } else {
              this.showErrorMessageWithButtonAndRedirect(
                "Ops..",
                "Para entrar no auditório você precisa estar logado e habilitado para esse leilão. Clique em OK para ser redirecionado para a tela de login.",
                "/login"
              );
              //this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButtonAndReloadIfConfirm("Ops..", "Houve um problema com a sua solicitação. Clique em OK para atualizar a tela");
          }
        });
    },

    findDoc(id) {
      let indice = this.documentos.findIndex((element) => element["id"] == id);

      return indice;
    },

    selecionarFoto(foto, indice_atual) {
      //this.indice_atual = indice_atual;
      this.foto_selecionada = foto;
    },

    fotoAnterior(indice_atual) {
      if (indice_atual >= 0) {
        this.indice_atual = indice_atual;
        this.foto_selecionada = this.fotos[indice_atual];
      }
    },

    proximaFoto(indice_atual) {
      if (indice_atual < this.fotos.length) {
        this.indice_atual = indice_atual;
        this.foto_selecionada = this.fotos[indice_atual];
      }
    },

    getLink(documento) {
      //console.log(documento);

      if (documento.path.includes("rochaleiloes2")) {
        return process.env.MIX_VUE_APP_S3_BASE2_URL + documento.path + "/" + documento.file;
      } else if (documento.path.includes("rochaleiloes")) {
        return process.env.MIX_VUE_APP_S3_BASE_URL + documento.path + "/" + documento.file;
      } else {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + documento.path + "/" + documento.file;
      }
    },

    getImagePath() {
      if (this.leilao.path) {
        if (this.leilao.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + this.leilao.path + "/" + this.leilao.arquivo;
        } else if (this.leilao.path.includes("rochaleiloes") || this.leilao.arquivo.includes("fotos_")) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + this.leilao.path + "/" + this.leilao.arquivo;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.leilao.path + "/" + this.leilao.arquivo;
        }
      }
    },

    getImageThumb(foto) {
      if (foto) {
        if (foto && foto.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + foto.path + "/" + foto.thumb;
        } else if ((foto && foto.path.includes("rochaleiloes")) || (foto && foto.img.includes("fotos_"))) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + foto.path + "/" + foto.img;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.img;
        }
      }
    },

    getImageFoto(foto) {
      if (foto) {
        if (foto && foto.path.includes("rochaleiloes2")) {
          return process.env.MIX_VUE_APP_S3_BASE2_URL + foto.path + "/" + foto.img;
        } else if ((foto && foto.path.includes("rochaleiloes")) || (foto && foto.img.includes("fotos_"))) {
          return process.env.MIX_VUE_APP_S3_BASE_URL + foto.path + "/" + foto.img;
        } else {
          return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + foto.path + "/" + foto.img;
        }
      }
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.validarLeilaoData();
        //this.pedirHabilitacao();
      } else {
        console.log(this.v$);
      }
    },

    validarLeilaoData() {
      let data = {
        leilao_id: this.leilao.id,
      };

      axios.post(`/user/leilao/serach_by_id`, data).then((response) => {
        let praca_atual = 0;
        let leilao = response.data.leilao;
        let proxima_data = "";

        //PRAÇA ATUAL
        if (leilao.leilao_num_pracas >= 1 && leilao.leilao_1_realizado == 0) {
          praca_atual = 1;
          proxima_data = leilao.leilao_1_data;
        } else if (leilao.leilao_num_pracas >= 2 && leilao.leilao_2_realizado == 0) {
          praca_atual = 2;
          proxima_data = leilao.leilao_2_data;
        } else if (leilao.leilao_num_pracas >= 3 && leilao.leilao_3_realizado == 0) {
          praca_atual = 3;
          proxima_data = leilao.leilao_3_data;
        } else if (leilao.leilao_num_pracas >= 4 && leilao.leilao_4_realizado == 0) {
          praca_atual = 4;
          proxima_data = leilao.leilao_4_data;
        }

        console.log("Limite hab");
        console.log(this.leilao.leilao_tempo_limite_habilitacao);
        console.log(this.leilao.leilao_tempo_limite_habilitacao >= 0);

        //VERIFICANDO SE TEM DATA PRA ENCERRAR HABILITAÇÕES
        if (this.leilao.leilao_tempo_limite_habilitacao >= 0) {
          console.log("Entrou na validação data");

          var data_agora = moment(new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }), "MM-DD-YYYY HH:mm:ss A");
          var data_proxima_praca = moment(proxima_data);

          console.log("Data agora 1");
          console.log(proxima_data);
          console.log(data_agora.format("DD/MM/yyyy HH:mm:ss"));
          console.log(data_proxima_praca.format("DD/MM/yyyy HH:mm:ss"));

          if (data_proxima_praca.format("DD/MM/yyyy HH:mm:ss") != "Invalid date") {
            let minutos = this.leilao.leilao_tempo_limite_habilitacao ? this.leilao.leilao_tempo_limite_habilitacao : 0;

            data_proxima_praca = data_proxima_praca.subtract(minutos, "minutes");

            console.log("Data agora 2");
            console.log(data_agora.format("DD/MM/yyyy HH:mm:ss"));
            console.log(data_proxima_praca.format("DD/MM/yyyy HH:mm:ss"));

            if (data_agora.isAfter(data_proxima_praca)) {
              let msg =
                "Não é possível pedir habilitação. As habilitações encerraram em " +
                data_proxima_praca.format("DD/MM/yyyy") +
                " às " +
                data_proxima_praca.format("HH:mm:ss");
              this.showErrorMessageWithButton("Ops...", msg);
            } else {
              this.pedirHabilitacao();
            }
          } else {
            this.showErrorMessageWithButton("Ops...", "Não foi possível solicitar habilitação.");
          }
        } else if (this.leilao.leilao_tempo_limite_habilitacao == -1) {
          let msg =
            "Não é possível pedir habilitação. As habilitações encerraram em " +
            moment(proxima_data).format("DD/MM/yyyy") +
            " às " +
            moment(proxima_data).format("HH:mm:ss");

          this.showErrorMessageWithButton("Ops...", msg);
        } else {
          console.log("Pulou validação data");
          this.pedirHabilitacao();
        }

        /*
        console.log("Data agora");
        console.log(data_agora.format("yyyy-MM-DD HH:mm:ss"));

        console.log("Próxima praça validação");
        console.log(data_proxima_praca.format("yyyy-MM-DD HH:mm:ss"));
        */

        /*
        day = day.subtract(20, "minutes");

        console.log("Data -20");
        console.log(day.format("yyyy-MM-DD HH:mm:ss"));
        */

        /*
        if (response.data.sucesso) {
          this.isLoading = true;

          console.log("Busca");
          console.log(data);

          axios
            .post(`/user/habilitacao/pedir`, data)
            .then((response) => {
              console.log("Retorno habilitação");
              console.log(response.data);

              this.isLoading = false;

              if (response.data.success) {
                this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Habilitação solicitada!", "/lote/" + this.lote.id);
              } else {
                this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
              }
            })
            .catch((error) => {
              this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
              console.log(error.response.data);
            });
        } else {
          let msg =
            "Não é possível pedir habilitação. As habilitações encerraram em " +
            this.formatOnlyDate(this.leilao.leilao_data_disponibilizar) +
            " às " +
            this.formatOnlyTime(this.leilao.leilao_data_disponibilizar);
          this.showErrorMessageWithButton("Ops...", msg);
        }
          */
      });
    },

    pedirHabilitacao() {
      this.isLoading = true;

      let data = {
        leilao_id: this.leilao.id,
      };

      console.log("Busca");
      console.log(data);

      axios
        .post(`/user/habilitacao/pedir`, data)
        .then((response) => {
          console.log("Retorno habilitação");
          console.log(response.data);

          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Habilitação solicitada!", "/lote/" + this.lote.id);
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
          }
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    /*
    pedirHabilitacao() {
      let data = {
        leilao_id: this.leilao.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/validar_tempo_habilitacao`, data).then((response) => {
        //if (response.data.sucesso) {
        if (true) {
          this.isLoading = true;

          console.log("Busca");
          console.log(data);

          axios
            .post(`/user/habilitacao/pedir`, data)
            .then((response) => {
              console.log("Retorno habilitação");
              console.log(response.data);

              this.isLoading = false;

              if (response.data.success) {
                this.showSuccessMessageWithButtonAndRedirect("Sucesso", "Habilitação solicitada!", "/lote/" + this.lote.id);
              } else {
                this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/lote/" + this.lote.id);
              }
            })
            .catch((error) => {
              this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
              console.log(error.response.data);
            });
        } else {
          let msg =
            "Não é possível pedir habilitação. As habilitações encerraram em " +
            this.formatOnlyDate(this.leilao.leilao_data_disponibilizar) +
            " às " +
            this.formatOnlyTime(this.leilao.leilao_data_disponibilizar);
          this.showErrorMessageWithButton("Ops...", msg);
        }
      });
    },
    */

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatOnlyDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatOnlyTime(date) {
      return moment(date).format("HH:mm");
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
p {
  padding: 0px 0px 0px 0px;
  margin: 3px 0px 3px 0px;
}

.half {
  width: 50%;
}
.full {
  width: 100%;
}

.img-t {
  transition-duration: 500ms;
  transform: scale(1.4);
}

.ic:hover {
  transition-duration: 500ms;
  transform: scale(1.4);
  color: #696969;
}

.im {
  width: 1500px;
}

.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.modal-content {
  width: 1100px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -20px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 600px;
    margin-left: -20px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.realizado {
  text-decoration: line-through;
}
</style>
